import {useState} from 'react';
import {ToastHelpers} from '../../../shared/helpers/toastHelpers';

type MutationFn<P, R> = (params: P) => Promise<R>;
type Cb<R> = (res: R) => Promise<void> | void;
type MutationOptions = {
  skipSuccessToast?: boolean;
};

interface MutationResult<P, R> {
  mutate: (params: P, cb?: Cb<R>, options?: MutationOptions) => Promise<void>;
  loading: boolean;
  error: unknown;
}

export function createMutation<P, R>(mutationFn: MutationFn<P, R>) {
  return function useMutation(): MutationResult<P, R> {
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState<unknown>(null);

    const mutate = async (params: P, cb?: Cb<R>, options?: MutationOptions) => {
      setLoading(true);
      setError(null);
      try {
        const res = await mutationFn(params);
        await cb?.(res);
        if (!options?.skipSuccessToast) {
          ToastHelpers.success('Операция выполнена успешно');
        }
      } catch (e) {
        setError(e);
        ToastHelpers.error(e);
      } finally {
        setLoading(false);
      }
    };

    return {mutate, loading, error};
  };
}
